import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { navigate } from '@reach/router';
import { useStaticQuery, graphql } from 'gatsby';
import Img from 'gatsby-image';

import SEO from '../../seo';
import Wrapper from '../../elements/wrapper';
import { media, TransitionMixin } from '../../helpers';

const StarterFormContainer = styled.section`
    .form-wrapper {
        max-width: 450px;
        text-align: center;
        margin: 20px;
        padding-bottom: 70px;
        ${media.medium`margin: 0 auto;`}

        .title-container {
            h1 {
                font-size: 3rem;
                color: #000;
                font-family: neue-kabel, sans-serif;
                font-weight: 800;
                ${media.medium`font-size: 4rem;`}
            }
        }

        .input-row {
            text-align: left;
            margin-bottom: 20px;
            &.split {
                display: flex;
                flex-wrap: wrap;
                .input-container {
                    flex: 1 1 100%;
                    margin-bottom: 20px;
                    ${media.small`flex: 1; margin-bottom: 0px;`}
                    &:first-child {
                        ${media.small`margin-right: 15px;`}
                    }
                    &:last-child {
                        margin-bottom: 0px;
                    }
                }
            }
            &.deadline {
                margin-bottom: 40px;
                .input-container {
                    display: flex;
                    align-items: center;
                    label {
                        margin-right: 20px;
                        font-size: 21px;
                        font-weight: bold;
                        flex: 0 0 40%;
                    }

                    input {
                        flex: 1;
                    }
                }
            }
            &.submit {
                .input-container {
                    display: block;
                }
            }

            .input-container {
                flex: 1;
                display: flex;
                flex-wrap: wrap;
                > * {
                    flex: 1 1 100%;
                }
                label {
                    display: block;
                    font-weight: bold;
                    margin-bottom: 5px;
                    color: #000;
                    font-size: 0.8rem;
                }

                input {
                    background-color: #f2f0eb;
                    border: 1px solid #f2f0eb;
                    padding: 5px 0 5px 10px;
                    border-radius: 5px;
                }

                button {
                    background-color: #f74c34;
                    color: #fff;
                    font-weight: bold;
                    border-radius: 5px;
                    display: inline-block;
                    padding: 15px 20px;
                    border: 1px solid #f74c34;
                    font-family: neue-kabel, sans-serif;
                    font-weight: 800;
                    min-width: 185px;
                    ${TransitionMixin('.25s')};

                    &:hover {
                        background-color: #fff;
                        color: #f74c34;
                    }
                }
            }
        }

        h4 {
            padding-top: 20px;
            font-size: 1.1rem;
            color: #000;
        }
        .form-buttons-container {
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            margin-bottom: 20px;

            .btn-container {
                flex: 0 0 33.33%;
                margin-bottom: 20px;

                button {
                    background-color: #f2f0eb;
                    border: 3px solid #f2f0eb;
                    border-radius: 4px;
                    display: inline-block;
                    padding: 5px 10px;
                    border-radius: 20px;
                    font-weight: bold;
                    min-width: 130px;
                    font-size: 0.8rem;

                    &:hover,
                    &.active {
                        background-color: #f74c34;
                        border-color: #f74c34;
                        color: #fff;
                    }

                    &:focus,
                    &:active {
                        outline: 0;
                    }
                }
            }
        }
    }

    .icons-footer {
        .footer-title-container {
            text-align: center;
            margin-bottom: 40px;

            h3 {
                color: #000;
                font-family: neue-kabel, sans-serif;
                font-weight: 800;
                font-size: 2.5rem;
            }
        }
        .icons-wrapper {
            display: flex;
            align-items: flex-end;
            margin: 0 auto;
            ${media.large`max-width: 60vw;`}
            .item-container {
                flex: 1;
                > .inner-wrap {
                    max-width: 90%;
                    margin: 0 auto;

                    .image-container {
                        max-width: 70px;
                        margin: 0 auto 15px;
                    }
                    .content-container {
                        text-align: center;

                        h4 {
                            color: #000;
                            margin: 0 0 15px;
                        }

                        p {
                            font-size: 0.9rem;
                            color: #000;
                        }
                    }
                }
            }
        }
    }
`;

const formButtons = [
    {
        title: 'Ties',
    },
    {
        title: 'Chiffon Scarves',
    },
    {
        title: 'Neck Gaiters',
    },
    {
        title: 'Bow Ties',
    },
    {
        title: 'Infinity Scarves',
    },
    {
        title: 'Pocket Squares',
    },
];

// Form
const StarterForm = ({ setBrandedSettings, brandedSettings }) => {
    const data = useStaticQuery(graphql`
        query {
            allWpPage(filter: { title: { eq: "Branded Form" } }) {
                edges {
                    node {
                        id
                        branded_form_addons {
                            brandedFormIcons {
                                sectionTitle
                                icons {
                                    iconImage {
                                        localFile {
                                            childImageSharp {
                                                fluid(maxWidth: 300) {
                                                    ...GatsbyImageSharpFluid
                                                }
                                            }
                                        }
                                    }
                                    iconTitle
                                    iconCaption
                                }
                            }
                        }
                    }
                }
            }
        }
    `);

    const [date, setDate] = useState();
    const [maxDate, setMaxDate] = useState();

    function getDate() {
        let dateObject = new Date();
        let day = dateObject.getDate();
        let month = dateObject.getUTCMonth() + 1;
        let year = dateObject.getUTCFullYear();

        let dateString = year + '-' + month + '-' + day;
        let maxDateString = year + 1 + '-' + month + '-' + day;

        setDate(dateString);
        setMaxDate(maxDateString);
    }

    function handleInputChange(e) {
        console.log('input changing');
        setBrandedSettings({
            ...brandedSettings,
            [e.target.name]: e.target.value,
        });
    }

    function handleButtonClick(e, title) {
        e.preventDefault();

        let hasButtonBeenSelected =
            brandedSettings.interested_in.filter((item) => item === title)
                .length > 0;

        if (hasButtonBeenSelected) {
            // remove
            let newArray = brandedSettings.interested_in;
            newArray = newArray.filter((item) => item !== title);
            setBrandedSettings({
                ...brandedSettings,
                interested_in: newArray,
            });
        } else {
            // add
            let newArray = brandedSettings.interested_in;
            newArray.push(title);
            setBrandedSettings({
                ...brandedSettings,
                interested_in: newArray,
            });
        }
    }

    function handleDateChange(e) {
        setBrandedSettings({
            ...brandedSettings,
            [e.target.name]: e.target.value,
        });
    }

    function handleFormSubmit(e) {
        e.preventDefault();
        // TODO: send info to Klaviyo

        navigate('/branded/step-1');
    }

    useEffect(() => {
        getDate();

        // if (typeof window !== 'undefined') {
        //     let previousValues = JSON.parse(
        //         localStorage.getItem('brandedProgress')
        //     );
        //     setBrandedSettings(previousValues);
        // }
    }, []);

    const { sectionTitle, icons } =
        data?.allWpPage.edges[0].node.branded_form_addons.brandedFormIcons ||
        {};

    return (
        <StarterFormContainer>
            <SEO title="Let's Get Started –– Branded" />
            <Wrapper className="form-wrapper">
                <div className="title-container">
                    <h1>Let's Start</h1>
                </div>
                <div className="form-container">
                    <form>
                        <div className="input-row split">
                            <div className="input-container">
                                <label htmlFor="first_name">First Name</label>
                                <input
                                    type="text"
                                    name="first_name"
                                    value={brandedSettings['first_name']}
                                    onChange={(e) => handleInputChange(e)}
                                />
                            </div>
                            <div className="input-container">
                                <label htmlFor="last_name">Last Name</label>
                                <input
                                    type="text"
                                    name="last_name"
                                    value={brandedSettings['last_name']}
                                    onChange={(e) => handleInputChange(e)}
                                />
                            </div>
                        </div>
                        <div className="input-row">
                            <div className="input-container">
                                <label htmlFor="email">Email</label>
                                <input
                                    type="email"
                                    name="email"
                                    value={brandedSettings['email']}
                                    onChange={(e) => handleInputChange(e)}
                                />
                            </div>
                        </div>
                        <div className="input-row split">
                            <div className="input-container">
                                <label htmlFor="phone">Phone</label>
                                <input
                                    type="text"
                                    name="phone"
                                    value={brandedSettings['phone']}
                                    onChange={(e) => handleInputChange(e)}
                                />
                            </div>
                            <div className="input-container">
                                <label htmlFor="company">Company</label>
                                <input
                                    type="text"
                                    name="company"
                                    value={brandedSettings['company']}
                                    onChange={(e) => handleInputChange(e)}
                                />
                            </div>
                        </div>

                        <h4>What kind of products do you want to brand?</h4>

                        <div className="form-buttons-container">
                            {formButtons &&
                                formButtons.map((button) => {
                                    let isButtonActive =
                                        brandedSettings.interested_in.filter(
                                            (item) => item === button.title
                                        ).length > 0;

                                    return (
                                        <div className="btn-container">
                                            <button
                                                type="button"
                                                className={
                                                    isButtonActive
                                                        ? 'active'
                                                        : ''
                                                }
                                                onClick={(e) =>
                                                    handleButtonClick(
                                                        e,
                                                        button.title
                                                    )
                                                }
                                            >
                                                {button.title}
                                            </button>
                                        </div>
                                    );
                                })}
                        </div>

                        <div className="input-row deadline">
                            <div className="input-container">
                                <label htmlFor="deadline">
                                    In-hand Deadline
                                </label>
                                <input
                                    type="date"
                                    id="deadline"
                                    name="deadline"
                                    value={brandedSettings.deadline}
                                    min={date}
                                    max={maxDate}
                                    onChange={(e) => handleDateChange(e)}
                                />
                            </div>
                        </div>

                        <div className="input-row submit">
                            <div className="input-container">
                                <button
                                    type="submit"
                                    onClick={(e) => handleFormSubmit(e)}
                                >
                                    Start Designing
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </Wrapper>
            <Wrapper className="icons-footer">
                <div className="footer-title-container">
                    <h3>{sectionTitle}</h3>
                </div>
                <Wrapper className="icons-wrapper">
                    {icons?.map((icon) => {
                        const { iconImage, iconTitle, iconCaption } =
                            icon || {};

                        return (
                            <div className="item-container">
                                <div className="inner-wrap">
                                    <div className="image-container">
                                        <Img
                                            fluid={
                                                iconImage.localFile
                                                    .childImageSharp.fluid
                                            }
                                            alt={iconTitle + ' icon'}
                                        />
                                    </div>
                                    <div className="content-container">
                                        <h4>{iconTitle}</h4>
                                        <p>{iconCaption}</p>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </Wrapper>
            </Wrapper>
        </StarterFormContainer>
    );
};

export default StarterForm;
